module.exports = __webpack_public_path__ + "img/acmedDownloadInfoTable.5cfa9392.png";